import { defineCollection } from "@rebasepro/cms-types";
import type { CollectionConfig } from "@rebasepro/types";
import { personName, playerOf } from "../people";
import playersCollection from "./players";
import { moment } from "../words";

// A friend pass (songbuzz_friend_pass): the code that lets someone ask this person. `room` passes travel through a
// game and last a night; `link` passes are the shareable link or QR code, 7 days, and can be cancelled.
// backend/src/friends.ts creates and writes it.
const friendLinksCollection = defineCollection({
    name: "Friend links",
    singularName: "Friend link",
    slug: "friend_links",
    table: "songbuzz_friend_pass",
    description: "Live friend codes: from a game (room) or a shared link or QR code (link), until they expire.",
    securityRules: [
        { operation: "select", roles: ["admin"] },
        { operation: "delete", roles: ["admin"] },
    ],
    properties: {
        token: { name: "Code", type: "string", isId: "manual", admin: { readOnly: true, hideFromCollection: true } },
        who: { name: "Whose (id)", type: "string", validation: { required: true }, admin: { readOnly: true, hideFromCollection: true } },
        player: playerOf("Whose", "who", "player", (): CollectionConfig => playersCollection),
        kind: { name: "Kind", type: "string", validation: { required: true }, admin: { readOnly: true, Preview: "../../admin/src/previews/Words", customProps: { say: "linkKind" } } },
        expires: { name: "Expires", type: "date", validation: { required: true }, admin: { readOnly: true } },
    },
    admin: {
        icon: "Link",
        group: "System",
        openEntityMode: "side_panel",
        sort: ["expires", "desc"],
        display: {
            title: async ({ entity, context }) => personName(context, entity.values.who),
            subtitle: ({ entity }) => `${entity.values.kind === "link" ? "Shared link or QR code" : "From a game"} · ${new Date(String(entity.values.expires)).getTime() < Date.now() ? "expired" : "expires"} ${moment(entity.values.expires)}`,
            date: "expires",
        },
        form: {
            sections: [
                { key: "link", properties: ["player", "kind", "expires"] },
                { key: "ids", title: "Behind the scenes", collapsed: true, properties: ["token", "who"] },
            ],
        },
    },
});

export default friendLinksCollection;
